import { useCallback, useMemo } from 'react';
import { useBacklogDispatch, useBacklogSelector } from '../../../state';
import { setCheckboxSelectionMode } from '../../../state/actions/cards/checkbox-selection-mode';
import {
	cardClearRelativeCard,
	cardMultiSelect,
	cardMultiSelectExtend,
	cardMultiRemove,
} from '../../../state/actions/cards/selection';
import { getVisibleCardIds, getVisibleCardListIds } from '../../../state/selectors/cards';

export const useSelectActions = () => {
	const dispatch = useBacklogDispatch();
	const visibleCardIds = useBacklogSelector(getVisibleCardIds);
	const visibleCardListIds = useBacklogSelector(getVisibleCardListIds);

	const selectAllVisible = useCallback(() => {
		dispatch(cardMultiSelectExtend(visibleCardIds));
	}, [dispatch, visibleCardIds]);

	const clearAll = useCallback(() => {
		dispatch(cardMultiSelect([]));
		dispatch(cardClearRelativeCard());
		dispatch(setCheckboxSelectionMode(false));
	}, [dispatch]);

	const clearAllVisible = useCallback(() => {
		dispatch(cardMultiRemove(visibleCardIds));
		dispatch(setCheckboxSelectionMode(false));
	}, [dispatch, visibleCardIds]);

	const extraAnalyticsAttributes = useMemo(
		() => ({
			selectAll: {
				checkbox: {
					issue_ids: visibleCardIds,
					numSelectedSprints: visibleCardListIds.length,
					numSelectedCards: visibleCardIds.length,
				},
				option: {
					numSelectedCards: visibleCardIds.length,
				},
			},
			clearAll: {
				checkbox: {
					issue_ids: [],
					numSelectedSprints: 0,
					numSelectedCards: 0,
				},
				option: {
					numSelectedCards: 0,
				},
			},
		}),
		[visibleCardIds, visibleCardListIds],
	);

	return { selectAllVisible, clearAll, clearAllVisible, extraAnalyticsAttributes };
};
